import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DotBackgroundOverlayComponent } from './dot-background-overlay.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DotBackgroundOverlayComponent],
  exports: [DotBackgroundOverlayComponent],
})
export class DotBackgroundOverlayModule {}
